import { useState } from "react";
import { useNavigate } from "react-router";
import { useProfile } from "../components/ProfileContext";
import { Timestamp } from "../components/Timestamp";
import { Inspection } from "../models/Inspection";
import { RentalStatusDisplay } from "../components/RentalStatusDisplay";
import { getDB } from "../util/db";
import { SpinnerButton } from "../components/SpinnerButton";
import { afterRenderDelay, navigateToInspectionId } from "../util/utils";
import { SharingStatus } from "../components/SharingStatus";

export function InspectionsTable(props) {
	return 	<div className="table-responsive searchTable"><table className="table">
		<thead>
			<tr>
				<th></th>
				<th>Inspection</th>
				<th>Result</th>
				<th>Disp</th>
				<th>Date</th>
			</tr>
		</thead>
		<tbody>
			{props.inspections.map(insp => <InspectionsTableRow key={insp.id} inspection={insp} />)}
		</tbody>
	</table></div>;
}

function InspectionsTableRow(props) {
	let insp = props.inspection;
	let [isLoading, setIsLoading] = useState(false);
	let navigate = useNavigate();
	let [profile] = useProfile();

	let viewInspectionAction = () => {
		setIsLoading(true);

		afterRenderDelay(async () => {
			try {
				await navigateToInspectionId(profile, navigate, insp.id)
			} catch(err) {			
				alert(`Unable to load inspection: ${err}`);
				setIsLoading(false);
			}	
		});
	};

	return <tr className="my-2">
		<td>
			<SpinnerButton className="prevButton" spinning={isLoading} onClick={viewInspectionAction}>
				{insp.completedAt == null ? "Edit" : "View"}
			</SpinnerButton>
		</td>
		<td>{insp.survey.name} <RentalStatusDisplay inspection={insp} /> <SharingStatus ownerUid={insp.userIdentifier} profile={profile} childAutoAccess={false} />
</td>
		<td>{insp.result}</td>
		<td>{insp.disposition}</td>
		<td><Timestamp dateString={insp.completedAt || insp.createdAt} formatter={profile.dateFormatter} /></td>
	</tr>;
}